import React from "react";
import img1 from "../integrationassets/implementation.jpg";
import "./IntegrationImplementation.css";

export default function IntegrationImplementation() {
  return (
    <section id="integration-implementation">
      <div className="outsource-offer-main">
        <div className="offer-item content content2">
          <h2>Dynamic Offerings in DevOps Test Automation</h2>
          <p>
            Advanced automation capabilities designed to enhance security,
            scalability, and delivery efficiency.
          </p>
          <ul>
            <li>
             Assessment & Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
             <li>
             Assessment & Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
             <li>
             Assessment & Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
             <li>
             Assessment & Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
          </ul>
        </div>

        <div className="offer-item image">
          <img src={img1} alt="DevOps Image 2" />
        </div>
      </div>
    </section>
  );
}
